export const getBrowserLanguage = () => (navigator.languages && navigator.languages[0])
    || navigator.language
    || navigator.userLanguage;
